export const classificationSociety = [
  "American Bureau of Shipping",
  "Biro Klasifikasi Indonesia",
  "Bulgarian Register of Shipping",
  "Bureau Colombo",
  "Bureau Veritas",
  "China Classification Society",
  "Croation Register",
  "DNV",
  "Deutsche Schiffs - Revision Und Klassn",
  "Germanischer Lloyd",
  "Hellenic Register of Shipping",
  "Indian Register of Shipping",
  "Korean Register",
  "Lloyds Register",
  "New Construction - Class Unknown",
  "Nippon Kaiji Kyokai",
  "The People's Republic of China Register of Shipping",
  "Phil Register of Shipping",
  "Polski Register",
  "Registro Brasileiro de Navios e Aeronaves",
  "Registro Cubana De Buques",
  "Registro Italiano Navale",
  "Registru Naval Roman",
  "Rinave Portugesa",
  "Russian Maritime Register of Shipping",
  "Taiwan Register",
  "Turk Loydu",
  "Unknown",
  "Vietnamese Register",
  "Yugoslav Register",
];
